import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, inject } from '@angular/core';

let ttDrawerUniqueId = 0;

@Component({
  selector: 'tt-drawer-content',
  template: '<ng-content />',
  styleUrls: ['./drawer.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerContentComponent {
  public elementRef = inject(ElementRef);
  private changeDetectorRef = inject(ChangeDetectorRef);

  private ttDrawerUniqueId = ttDrawerUniqueId++;

  private initialMarginRightSet = false;
  private initialMarginLeftSet = false;

  @HostBinding('class.tt-drawer-content') hostCls = true;

  constructor() {
    this.elementRef.nativeElement.style.setProperty('margin-right', `var(--tt-drawer-margin-right-${this.ttDrawerUniqueId})`);
    this.elementRef.nativeElement.style.setProperty('margin-left', `var(--tt-drawer-margin-left-${this.ttDrawerUniqueId})`);
    this.elementRef.nativeElement.style.setProperty(
      'width',
      `calc(100% - var(--tt-drawer-margin-right-${this.ttDrawerUniqueId}, 0px) - var(--tt-drawer-margin-left-${this.ttDrawerUniqueId}, 0px))`,
    );
  }

  public setMarginRight(marginRight: number): void {
    if (this.initialMarginRightSet) {
      this.elementRef.nativeElement.classList.add('tt-drawer-content--animate');
    }

    this.elementRef.nativeElement.style.setProperty(`--tt-drawer-margin-right-${this.ttDrawerUniqueId}`, `${marginRight}px`);
    this.changeDetectorRef.detectChanges();

    this.initialMarginRightSet = true;
  }

  public setMarginLeft(marginLeft: number): void {
    if (this.initialMarginLeftSet) {
      this.elementRef.nativeElement.classList.add('tt-drawer-content--animate');
    }

    this.elementRef.nativeElement.style.setProperty(`--tt-drawer-margin-left-${this.ttDrawerUniqueId}`, `${marginLeft}px`);
    this.changeDetectorRef.detectChanges();

    this.initialMarginLeftSet = true;
  }
}
